import { AnalyseConstants } from '../../../_constants';

const initialState = { saveAssesorIdsLoading: true, data: '', error: false };

export function saveAssesorIdsReducer(state = initialState, action) {
   
    switch (action.type) {
        case AnalyseConstants.REQUEST_SAVE_ASSESOR_IDS:
        return {
            saveAssesorIdsLoading: false,
            data: state.data,
            error: false
        };
        case AnalyseConstants.RECEIVE_SAVE_ASSESOR_IDS:
            return {
                saveAssesorIdsLoading: false,
                data: action.data,
                error: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/AssessorList/saveAssessorIds.reducer.js